import React from 'react'

import { createValidIcon } from '@ui/icons/utils/type-helper'

export const UndoUpRightIcon = createValidIcon((props) => {
  const { size, color } = props

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 20 20'
      fill='none'
    >
      <path
        d='M13.5771 3.57704C13.9026 3.25163 14.4304 3.2517 14.7559 3.57704L18.0889 6.91102C18.4142 7.23647 18.4143 7.76334 18.0889 8.08876L14.7559 11.4227C14.4304 11.7479 13.9025 11.748 13.5771 11.4227C13.2518 11.0974 13.2519 10.5695 13.5771 10.244L15.4883 8.3329H6.66699C4.82604 8.3329 3.33301 9.82593 3.33301 11.6669C3.33326 13.5076 4.8262 14.9999 6.66699 14.9999H10.833C11.2932 14.9999 11.6669 15.3727 11.667 15.8329C11.667 16.2931 11.2932 16.6669 10.833 16.6669H6.66699C3.90572 16.6669 1.66724 14.4281 1.66699 11.6669C1.66699 8.90546 3.90557 6.66688 6.66699 6.66688H15.4883L13.5771 4.75575C13.2518 4.43033 13.2518 3.90245 13.5771 3.57704Z'
        fill={color}
      />
    </svg>
  )
})
